import { Link } from 'react-router-dom';

export default function AdminNavbar({ user }) {
  const name = [user?.firstName, user?.lastName].filter(Boolean).join(' ') || 'Administrator';
  return (
    <header className="admin-navbar">
      <div>
        <p className="eyebrow">Store operations</p>
        <h1>Admin Dashboard</h1>
        <p>Catalogue, inventory, customers, orders and fulfilment in one secure workspace.</p>
      </div>
      <div className="admin-identity">
        <span>Signed in as</span>
        <strong>{name}</strong>
        <small>{user?.email}</small>
        <Link className="text-button" to="/">View storefront</Link>
      </div>
    </header>
  );
}
